<template>
  <div class="menu_section">
    <div class="kichen-bar" :class="addActiveClass" @click="pickMenu">
      <div class="menu_section_item kichen">
        <div class="text-content text-kichen">кухня</div>
      </div>
      <div class="menu_section_item bar">
        <div class="text-content text-bar">бар</div>
      </div>
      <!-- <div class="menu_section_item sushi">
        <div class="text-content text-sushi">суші</div>
      </div> -->
      <div class="menu_section_item delivery">
        <div class="text-content text-delivery">доставка</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KichenBar",
  data: () => ({
    activeSectionData: false,
  }),
  computed: {
    addActiveClass() {
      return {
        active: this.activeSectionData,
      };
    },
  },
  methods: {
    pickMenu(e) {
      this.$emit("pickMenu", e);
      this.activeSectionData = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.kichen-bar {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  // padding-bottom: 235px;
  margin-top: 130px;
  right: 0;
  transition: all 0.4s ease;
  .menu_section_item {
    height: 120px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    box-shadow: 1px 1px 10px black;
    border-radius: 15px;
    margin: 15px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    .text-content {
      position: absolute;
      font-size: 30px;
      color: #fff;
      text-transform: uppercase;
      letter-spacing: 2px;
      text-align: center;
      z-index: 2;
    }
  }
  .kichen {
    background-image: url("../../public/main_page/kichen.jpg");
    &::before {
      content: "";
      position: relative;
      width: 100%;
      height: inherit;
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 15px;
    }
  }
  .bar {
    background-image: url("../../public/main_page/bar.JPG");
    &::before {
      content: "";
      position: relative;
      width: 100%;
      height: inherit;
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 15px;
      z-index: 1;
    }
  }

  .sushi {
    background-image: url("../../public/main_page/sushi.jpeg");
    &::before {
      content: "";
      position: relative;
      width: 100%;
      height: inherit;
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 15px;
      z-index: 1;
    }
  }
  .delivery {
    background: rgb(34, 193, 195);
    background: linear-gradient(
      336deg,
      rgba(34, 193, 195, 1) 0%,
      rgba(34, 62, 73, 1) 48%
    );
    &::before {
      content: "";
      position: relative;
      width: 100%;
      height: inherit;
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 15px;
      z-index: 1;
    }
  }
}
.active {
  right: 400px;
  opacity: 0;
  transition: all 0.4s ease;
}
</style>
